import angular from 'angular';
import _ from 'underscore';
import $ from 'jquery';

export default class MessageCreate {
  constructor($scope, $rootScope, MessageService, ProductService, UserService) {
    $scope.create = function() {
      $scope.creating = true;
      update_business_types();
      update_user_groups();
      update_business_relations();
      update_products();
      update_product_groups();
      update_product_categories();
      update_suppliers();
      MessageService.create($scope.message).success(function(data) {
        if (data.success)
          window.location = '/admin/marketplace/messages';
      });
    };
    
    $scope.set_buyer_autocomplete = function(input) {
      input.autocomplete({
        delay: 300,
        source: function(request, response) {
          UserService.search_by_company('Buyer', request.term).then(function(data) {
            response(data.users);
          });
        },
        select: function(event, ui) {
          $scope.message.user_id = ui.item.id;
          $scope.buyer_company = ui.item.value;
          console.log($scope.message);
        }
      });
    };
    
    $scope.set_supplier_autocomplete = function(input) {
      input.autocomplete({
        delay: 300,
        source: function(request, response) {
          UserService.search_by_company('Seller', request.term).then(function(data) {
            response(data.users);
          });
        },
        select: function(event, ui) {
          if (!_.findWhere($scope.suppliers, {id: ui.item.id}))
            $scope.suppliers.push({
              id: ui.item.id,
              title: ui.item.value
            });
          $(this).val('');
          $scope.$apply();
          return false;
        }
      });
    };
    
    function update_business_types() {
      $scope.message.business_types = [];
      angular.forEach($scope.business_types, function(business_type) {
        if (business_type.checked)
          $scope.message.business_types.push(business_type.id);
      });
    }
    
    function update_user_groups() {
      $scope.message.user_groups = [];
      angular.forEach($scope.user_groups, function(group) {
        if (group.checked)
          $scope.message.user_groups.push(group.id);
      });
    }
    
    function update_business_relations() {
      $scope.message.business_relations = [];
      angular.forEach($scope.business_relations, function(group) {
        if (group.checked)
          $scope.message.business_relations.push(group.id);
      });
    }

    
    function update_products() {
      $scope.message.products = [];
      angular.forEach($scope.epaper_products, function(group) {
        $scope.message.products.push(group.id);
      });
    }

    function update_product_groups() {
      $scope.message.product_groups = [];
      angular.forEach($scope.product_groups, function(group) {
        $scope.message.product_groups.push(group.id);
      });
    }

    function update_product_categories() {
      $scope.message.product_categories = [];
      angular.forEach($scope.product_categories, function(group) {
        if (group.checked)
          $scope.message.product_categories.push(group.id);
      });
    }
    
    function update_suppliers() {
      $scope.message.suppliers = [];
      angular.forEach($scope.suppliers, function(supplier) {
        $scope.message.suppliers.push(supplier.id);
      });
    }

    $scope.set_product_autocomplete = function(input) {
      input.autocomplete({
        delay: 300,
        source: function(request, response) {
          ProductService.search_products_by_title(request.term).then(function(data) {
            response(data.products);
          });
        },
        select: function(event, ui) {
          if (!_.findWhere($scope.epaper_products, {id: ui.item.id}))
            $scope.epaper_products.push({
              id: ui.item.id,
              title: ui.item.value
            });
          $(this).val('');
          $scope.$apply();
          return false;
        }
      });
    };

    $scope.set_product_group_autocomplete = function(input) {
      input.autocomplete({
        delay: 300,
        source: function(request, response) {
          ProductService.search_product_groups_by_title(request.term).then(function(data) {
            response(data.groups);
          });
        },
        select: function(event, ui) {
          if (!_.findWhere($scope.product_groups, {id: ui.item.id}))
            $scope.product_groups.push({
              id: ui.item.id,
              title: ui.item.value
            });
          $(this).val('');
          $scope.$apply();
          return false;
        }
      });
    };

    $scope.remove_epaper_product = function(product_id) {
      $scope.epaper_products = _.reject($scope.epaper_products, function(product) {
        return product.id == product_id;
      });
      $('input.epaper_product').val('');
    };

    $scope.remove_product_group = function(group_id) {
      $scope.product_groups = _.reject($scope.product_groups, function(group) {
        return group.id == group_id;
      });
      $('input.group').val('');
    };
    
    $scope.remove_supplier = function(supplier_id) {
      $scope.suppliers = _.reject($scope.suppliers, function(supplier) {
        return supplier.id == supplier_id;
      });
      $('input.supplier').val('');
    };
    
    $scope.init = function() {
      $scope.message = {
        title: window.message_title,
      };
      
      $scope.business_types = angular.copy(window.business_types);
      $scope.user_groups = angular.copy(window.user_groups);
      $scope.business_relations = angular.copy(window.business_relations);
      $scope.product_categories = angular.copy(window.product_categories);
      $scope.product_groups = [];
      $scope.epaper_products = [];
      $scope.suppliers = [];
      
      $scope.set_product_autocomplete($('input.epaper_product'));
      $scope.set_product_group_autocomplete($('input.group'));
      $scope.set_buyer_autocomplete($('input.buyer_company'));
      $scope.set_supplier_autocomplete($('input.supplier'));
    };


    $scope.init();
  }
}

MessageCreate.$inject = ['$scope', '$rootScope', 'MessageService', 'ProductService', 'UserService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/message-create.ctrl.js